var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import { useAllIntegrations } from "../../../utils/hooks/integrations/useIntegrations";
var FilterSourceConfigInput = function (_a) {
    var ids = _a.ids, setIds = _a.setIds;
    var allIntegrations = useAllIntegrations();
    var selectedIntegrations = allIntegrations.filter(function (integration) { return ids === null || ids === void 0 ? void 0 : ids.includes(integration.id); });
    return (_jsx(Autocomplete, { id: "sector-find", multiple: true, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.fullName || ''; }, options: allIntegrations, fullWidth: true, value: selectedIntegrations, onChange: function (e, value) {
            setIds(value.map(function (v) { return v.id; }) || []);
        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { size: 'small', fullWidth: true }))); } }));
};
export default FilterSourceConfigInput;
